// Story 10.3 — Empty state cuando el bot aún no tiene mensajes.

import { Copy, MessageSquare } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface Props {
  phoneNumberId: string | null;
}

export function EmptyConversations({ phoneNumberId }: Props): React.ReactElement {
  const [copied, setCopied] = useState(false);
  const snippet = phoneNumberId
    ? `Envía 'hola' al número asociado a ${phoneNumberId} para empezar a conversar.`
    : 'Configura el número de WhatsApp del bot y envíale "hola" para empezar.';

  async function handleCopy(): Promise<void> {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(snippet);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  }

  return (
    <Card className="mx-auto max-w-2xl">
      <CardHeader className="items-center text-center">
        <div className="rounded-full bg-primary/10 p-4">
          <MessageSquare className="h-8 w-8 text-primary" aria-hidden />
        </div>
        <CardTitle>Tu bot está listo</CardTitle>
        <CardDescription>Aún no ha recibido mensajes.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <pre className="overflow-x-auto rounded-md border border-border bg-muted/50 p-3 text-sm">
          <code>{snippet}</code>
        </pre>
        <div className="flex flex-wrap justify-center gap-2">
          <Button onClick={handleCopy} variant="default">
            <Copy className="h-4 w-4" />
            {copied ? 'Copiado' : 'Copiar snippet'}
          </Button>
          <Button variant="outline" asChild>
            <a
              href="https://developers.facebook.com/docs/whatsapp/cloud-api/get-started"
              target="_blank"
              rel="noreferrer"
            >
              Documentación de WhatsApp Business
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
